import { useTokensStoreGeneral } from '@/src/hooks/useTokensStoreGeneral';
import { InvestUnitEntity, InvestUnitWithDetailsEntity } from '@/src/lib/MayzSmartDB/Entities/index';
import { Token_For_Store } from '@/src/store/global';
import { useEffect, useState } from 'react';

export default function useInvestUnitSmall({ investUnit, investUnitWithDetails }: { investUnit?: InvestUnitEntity; investUnitWithDetails?: InvestUnitWithDetailsEntity }) {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { isTokensStoreReady, isTokensStoreLoading, setTokensToGet, tokensFromStore } = useTokensStoreGeneral({
        name: 'InvestUnit',
        tokensToGet: undefined,
        dependenciesInit: [],
        followUp: undefined,
        keepAlive: undefined,
        swAddPrice: false,
        swAddMetadata: true,
        initPriceUpdater: false,
        swHandleCreateJob: true,
    });
    //--------------------------------------
    useEffect(() => {
        if (
            (investUnit?.iudInvestUnit?.iuValues !== undefined && investUnit.iudInvestUnit.iuValues.length > 0) ||
            (investUnitWithDetails?.investUnitWithADAPrices?.iuValuesWithDetailsAndAmount !== undefined &&
                investUnitWithDetails.investUnitWithADAPrices.iuValuesWithDetailsAndAmount.length > 0)
        ) {
            //--------------------------------------
            let tokensFromInvestUnit: Partial<Token_For_Store>[] = [];
            //--------------------------------------
            if (
                investUnitWithDetails?.investUnitWithADAPrices?.iuValuesWithDetailsAndAmount !== undefined &&
                investUnitWithDetails.investUnitWithADAPrices.iuValuesWithDetailsAndAmount.length > 0
            ) {
                tokensFromInvestUnit = investUnitWithDetails.investUnitWithADAPrices.iuValuesWithDetailsAndAmount.map((token_) => {
                    const token: Partial<Token_For_Store> = {
                        ...token_,
                        CS: token_.CS,
                        TN_Hex: token_.TN_Hex,
                    };
                    return token;
                });
            } else if (investUnit?.iudInvestUnit?.iuValues !== undefined && investUnit.iudInvestUnit.iuValues.length > 0) {
                tokensFromInvestUnit = investUnit.iudInvestUnit.iuValues.map((token_) => {
                    const token: Partial<Token_For_Store> = {
                        CS: token_[0],
                        TN_Hex: token_[1],
                    };
                    return token;
                });
                //--------------------------------------
            }
            //--------------------------------------
            setTokensToGet(tokensFromInvestUnit);
            //--------------------------------------
        }
    }, [investUnit, investUnitWithDetails]);
    //--------------------------------------
    return {
        isRefreshing,
        isTokensStoreLoading,
        tokensMetadata: tokensFromStore,
    };
    //--------------------------------------
}
